import { motion } from "framer-motion";
import axios from "axios";
import { useRef, useEffect, useState } from "react";
import { API_ENDPOINT } from "../../../../../lib/api-url";

const TEAM_TO_LOGO = {
  GOLDENEAGLES: "goldeneagles-transform.svg",
  GOLDEN_EAGLES: "goldeneagles-transform.svg",
  BULLMASTERS: "bullmasters-transform-logo.svg",
  IRONBEARS: "ironbears-transform-market.svg",
  ALPHAWOLVES: "alphawolves-transform.svg",
};
const parsePrice = (p) => {
  const n = Number(p);
  return Number.isFinite(n) ? n : 0;
};
const logoFromTeam = (user) => {
  const team = user?.team;
  if (!team) return null;
  if (team.logo_path) {
    return team.logo_path.startsWith("/")
      ? team.logo_path
      : `/transform-market/${team.logo_path}`;
  }
  const key = String(team.name || "")
    .toUpperCase()
    .replace(/\s+/g, "_");
  const mapped = TEAM_TO_LOGO[key];
  return mapped ? `/transform-market/${mapped}` : null;
};
const Transfor = ({ index, name, price, imgUrl, num }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: index * 0.2, duration: 0.5 }}
  >
    <div className="relative">
      <img src="/transform-market/transfor-card.svg" alt="Card" />
      <div className="absolute top-0 items-center w-full h-full flex-row-reverse flex text-white ">
        <div className="h-full w-[116px] shrink-0">
          <div className=" h-[73px] w-full flex flex-row-reverse items-end">
            <img
              src={"/avatar/avatar-default.webp"}
              className="w-[77px] h-fit"
              alt="Avatar"
            />
          </div>
        </div>
        <div
          style={{ fontFamily: "Peyda" }}
          className="w-full text-[18px] text-white text-center"
        >
          {name}
        </div>
        <div
          style={{ fontFamily: "Etemad" }}
          className="w-full text-center text-[22px] text-[#40BF6A]"
        >
          {price}$
        </div>
        <div
          style={{ fontFamily: "Etemad" }}
          className="w-[66px] text-[18px] text-white shrink-0 pl-[10px] h-full pt-[6px]"
        >
          {num}
        </div>
      </div>
    </div>
  </motion.div>
);

const TransforMarket = () => {
  const containerRef = useRef(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const fadeDelay = 0.3 * 10;
    const totalDelay = fadeDelay + 1;

    let scrolling = false;
    let frameId;

    const smoothScroll = (to, duration, callback) => {
      const start = container.scrollTop;
      const change = to - start;
      const startTime = performance.now();

      const animateScroll = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 0.5 - Math.cos(progress * Math.PI) / 2;
        container.scrollTop = start + change * ease;

        if (progress < 1) {
          frameId = requestAnimationFrame(animateScroll);
        } else if (callback) callback();
      };

      frameId = requestAnimationFrame(animateScroll);
    };

    const startAutoScroll = () => {
      const scrollDown = () => {
        if (scrolling) return;

        const { scrollTop, scrollHeight, clientHeight } = container;
        const reachedBottom = scrollTop + clientHeight >= scrollHeight - 5;

        if (reachedBottom) {
          scrolling = true;
          setTimeout(() => {
            smoothScroll(0, 2000, () => {
              scrolling = false;
              requestAnimationFrame(scrollDown);
            });
          }, 1000);
        } else {
          container.scrollTop += 5;
          frameId = requestAnimationFrame(scrollDown);
        }
      };

      scrollDown();
    };

    const timer = setTimeout(startAutoScroll, totalDelay * 1000);

    return () => {
      cancelAnimationFrame(frameId);
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setLoading(true);
        const res = await axios.get(API_ENDPOINT.wallTransferMarket.getIndex);
        const data = Array.isArray(res?.data?.data) ? res.data.data : [];
        const sorted = [...data].sort(
          (a, b) => parsePrice(b.price) - parsePrice(a.price)
        );
        if (mounted) setRows(sorted.slice(0, 20));
      } catch (e) {
        console.error(e);
        if (mounted) setErr("Failed to fetch transfer market.");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="w-full h-full pt-10 pb-28 flex justify-center relative items-center">
      <div
        ref={containerRef}
        className="w-fit flex flex-col gap-16 pt-10 h-[700px] hide-scrollbar overflow-y-auto scroll-smooth"
      >
        {rows.length > 0 &&
          rows.map((item, index) => (
            <Transfor
              key={index}
              num={index + 1}
              price={item.price}
              name={item.user.first_name + " " + item.user.last_name}
              index={index}
              imgUrl={logoFromTeam(item.user)}
            />
          ))}
      </div>
    </div>
  );
};

export default TransforMarket;
